{
  "commons": {
    "pending": "Pendiente",
    "inProgress": "En progreso",
    "readyToWrap": "En progreso",
    "readyForLoading": "En progreso",
    "bulk": "Granel",
    "cleaning": "Limpieza",
    "others": "Otros"
  },
  "loader": {
    "message": "Aguarde, por favor..."
  },
  "validations": {
    "generic-error": "Algo salió mal"
  },
  "assembly": {
    "title": "Armado"
  }
}